module.exports = {
  "spinAround": "__re-bulma_spin-around",
  "box": "__re-bulma_box",
  "button": "__re-bulma_button",
  "isActive": "__re-bulma_is-active",
  "isDisabled": "__re-bulma_is-disabled",
  "icon": "__re-bulma_icon",
  "tag": "__re-bulma_tag",
  "isWhite": "__re-bulma_is-white",
  "isInverted": "__re-bulma_is-inverted",
  "isLoading": "__re-bulma_is-loading",
  "isOutlined": "__re-bulma_is-outlined",
  "isBlack": "__re-bulma_is-black",
  "isLight": "__re-bulma_is-light",
  "isDark": "__re-bulma_is-dark",
  "isPrimary": "__re-bulma_is-primary",
  "isInfo": "__re-bulma_is-info",
  "isSuccess": "__re-bulma_is-success",
  "isWarning": "__re-bulma_is-warning",
  "isDanger": "__re-bulma_is-danger",
  "isLink": "__re-bulma_is-link",
  "isSmall": "__re-bulma_is-small",
  "isMedium": "__re-bulma_is-medium",
  "isLarge": "__re-bulma_is-large",
  "isFullwidth": "__re-bulma_is-fullwidth",
  "fa": "__re-bulma_fa",
  "delete": "__re-bulma_delete",
  "modalClose": "__re-bulma_modal-close",
  "cardm": "__re-bulma_cardm",
  "cardHeader": "__re-bulma_card-header",
  "cardHeaderTitle": "__re-bulma_card-header-title",
  "cardFooter": "__re-bulma_card-footer",
  "cardHeaderIcon": "__re-bulma_card-header-icon",
  "cardFooterItem": "__re-bulma_card-footer-item",
  "cardContent": "__re-bulma_card-content",
  "cardImage": "__re-bulma_card-image",
  "title": "__re-bulma_title",
  "subtitle": "__re-bulma_subtitle",
  "card": "__re-bulma_card",
  "media": "__re-bulma_media",
  "isRounded": "__re-bulma_is-rounded",
  "column": "__re-bulma_column",
  "columns": "__re-bulma_columns",
  "isMobile": "__re-bulma_is-mobile",
  "isNarrow": "__re-bulma_is-narrow",
  "isFull": "__re-bulma_is-full",
  "isThreeQuarters": "__re-bulma_is-three-quarters",
  "isTwoThirds": "__re-bulma_is-two-thirds",
  "isHalf": "__re-bulma_is-half",
  "isOneThird": "__re-bulma_is-one-third",
  "isOneQuarter": "__re-bulma_is-one-quarter",
  "isOffsetThreeQuarters": "__re-bulma_is-offset-three-quarters",
  "isOffsetTwoThirds": "__re-bulma_is-offset-two-thirds",
  "isOffsetHalf": "__re-bulma_is-offset-half",
  "isOffsetOneThird": "__re-bulma_is-offset-one-third",
  "isOffsetOneQuarter": "__re-bulma_is-offset-one-quarter",
  "is1": "__re-bulma_is-1",
  "isOffset1": "__re-bulma_is-offset-1",
  "is2": "__re-bulma_is-2",
  "isOffset2": "__re-bulma_is-offset-2",
  "is3": "__re-bulma_is-3",
  "isOffset3": "__re-bulma_is-offset-3",
  "is4": "__re-bulma_is-4",
  "isOffset4": "__re-bulma_is-offset-4",
  "is5": "__re-bulma_is-5",
  "isOffset5": "__re-bulma_is-offset-5",
  "is6": "__re-bulma_is-6",
  "isOffset6": "__re-bulma_is-offset-6",
  "is7": "__re-bulma_is-7",
  "isOffset7": "__re-bulma_is-offset-7",
  "is8": "__re-bulma_is-8",
  "isOffset8": "__re-bulma_is-offset-8",
  "is9": "__re-bulma_is-9",
  "isOffset9": "__re-bulma_is-offset-9",
  "is10": "__re-bulma_is-10",
  "isOffset10": "__re-bulma_is-offset-10",
  "is11": "__re-bulma_is-11",
  "isOffset11": "__re-bulma_is-offset-11",
  "is12": "__re-bulma_is-12",
  "isOffset12": "__re-bulma_is-offset-12",
  "isNarrowMobile": "__re-bulma_is-narrow-mobile",
  "isFullMobile": "__re-bulma_is-full-mobile",
  "isThreeQuartersMobile": "__re-bulma_is-three-quarters-mobile",
  "isTwoThirdsMobile": "__re-bulma_is-two-thirds-mobile",
  "isHalfMobile": "__re-bulma_is-half-mobile",
  "isOneThirdMobile": "__re-bulma_is-one-third-mobile",
  "isOneQuarterMobile": "__re-bulma_is-one-quarter-mobile",
  "isOffsetThreeQuartersMobile": "__re-bulma_is-offset-three-quarters-mobile",
  "isOffsetTwoThirdsMobile": "__re-bulma_is-offset-two-thirds-mobile",
  "isOffsetHalfMobile": "__re-bulma_is-offset-half-mobile",
  "isOffsetOneThirdMobile": "__re-bulma_is-offset-one-third-mobile",
  "isOffsetOneQuarterMobile": "__re-bulma_is-offset-one-quarter-mobile",
  "is1Mobile": "__re-bulma_is-1-mobile",
  "isOffset1Mobile": "__re-bulma_is-offset-1-mobile",
  "is2Mobile": "__re-bulma_is-2-mobile",
  "isOffset2Mobile": "__re-bulma_is-offset-2-mobile",
  "is3Mobile": "__re-bulma_is-3-mobile",
  "isOffset3Mobile": "__re-bulma_is-offset-3-mobile",
  "is4Mobile": "__re-bulma_is-4-mobile",
  "isOffset4Mobile": "__re-bulma_is-offset-4-mobile",
  "is5Mobile": "__re-bulma_is-5-mobile",
  "isOffset5Mobile": "__re-bulma_is-offset-5-mobile",
  "is6Mobile": "__re-bulma_is-6-mobile",
  "isOffset6Mobile": "__re-bulma_is-offset-6-mobile",
  "is7Mobile": "__re-bulma_is-7-mobile",
  "isOffset7Mobile": "__re-bulma_is-offset-7-mobile",
  "is8Mobile": "__re-bulma_is-8-mobile",
  "isOffset8Mobile": "__re-bulma_is-offset-8-mobile",
  "is9Mobile": "__re-bulma_is-9-mobile",
  "isOffset9Mobile": "__re-bulma_is-offset-9-mobile",
  "is10Mobile": "__re-bulma_is-10-mobile",
  "isOffset10Mobile": "__re-bulma_is-offset-10-mobile",
  "is11Mobile": "__re-bulma_is-11-mobile",
  "isOffset11Mobile": "__re-bulma_is-offset-11-mobile",
  "is12Mobile": "__re-bulma_is-12-mobile",
  "isOffset12Mobile": "__re-bulma_is-offset-12-mobile",
  "isNarrowTablet": "__re-bulma_is-narrow-tablet",
  "isFullTablet": "__re-bulma_is-full-tablet",
  "isThreeQuartersTablet": "__re-bulma_is-three-quarters-tablet",
  "isTwoThirdsTablet": "__re-bulma_is-two-thirds-tablet",
  "isHalfTablet": "__re-bulma_is-half-tablet",
  "isOneThirdTablet": "__re-bulma_is-one-third-tablet",
  "isOneQuarterTablet": "__re-bulma_is-one-quarter-tablet",
  "isOffsetThreeQuartersTablet": "__re-bulma_is-offset-three-quarters-tablet",
  "isOffsetTwoThirdsTablet": "__re-bulma_is-offset-two-thirds-tablet",
  "isOffsetHalfTablet": "__re-bulma_is-offset-half-tablet",
  "isOffsetOneThirdTablet": "__re-bulma_is-offset-one-third-tablet",
  "isOffsetOneQuarterTablet": "__re-bulma_is-offset-one-quarter-tablet",
  "is1Tablet": "__re-bulma_is-1-tablet",
  "isOffset1Tablet": "__re-bulma_is-offset-1-tablet",
  "is2Tablet": "__re-bulma_is-2-tablet",
  "isOffset2Tablet": "__re-bulma_is-offset-2-tablet",
  "is3Tablet": "__re-bulma_is-3-tablet",
  "isOffset3Tablet": "__re-bulma_is-offset-3-tablet",
  "is4Tablet": "__re-bulma_is-4-tablet",
  "isOffset4Tablet": "__re-bulma_is-offset-4-tablet",
  "is5Tablet": "__re-bulma_is-5-tablet",
  "isOffset5Tablet": "__re-bulma_is-offset-5-tablet",
  "is6Tablet": "__re-bulma_is-6-tablet",
  "isOffset6Tablet": "__re-bulma_is-offset-6-tablet",
  "is7Tablet": "__re-bulma_is-7-tablet",
  "isOffset7Tablet": "__re-bulma_is-offset-7-tablet",
  "is8Tablet": "__re-bulma_is-8-tablet",
  "isOffset8Tablet": "__re-bulma_is-offset-8-tablet",
  "is9Tablet": "__re-bulma_is-9-tablet",
  "isOffset9Tablet": "__re-bulma_is-offset-9-tablet",
  "is10Tablet": "__re-bulma_is-10-tablet",
  "isOffset10Tablet": "__re-bulma_is-offset-10-tablet",
  "is11Tablet": "__re-bulma_is-11-tablet",
  "isOffset11Tablet": "__re-bulma_is-offset-11-tablet",
  "is12Tablet": "__re-bulma_is-12-tablet",
  "isOffset12Tablet": "__re-bulma_is-offset-12-tablet",
  "isNarrowDesktop": "__re-bulma_is-narrow-desktop",
  "isFullDesktop": "__re-bulma_is-full-desktop",
  "isThreeQuartersDesktop": "__re-bulma_is-three-quarters-desktop",
  "isTwoThirdsDesktop": "__re-bulma_is-two-thirds-desktop",
  "isHalfDesktop": "__re-bulma_is-half-desktop",
  "isOneThirdDesktop": "__re-bulma_is-one-third-desktop",
  "isOneQuarterDesktop": "__re-bulma_is-one-quarter-desktop",
  "isOffsetThreeQuartersDesktop": "__re-bulma_is-offset-three-quarters-desktop",
  "isOffsetTwoThirdsDesktop": "__re-bulma_is-offset-two-thirds-desktop",
  "isOffsetHalfDesktop": "__re-bulma_is-offset-half-desktop",
  "isOffsetOneThirdDesktop": "__re-bulma_is-offset-one-third-desktop",
  "isOffsetOneQuarterDesktop": "__re-bulma_is-offset-one-quarter-desktop",
  "is1Desktop": "__re-bulma_is-1-desktop",
  "isOffset1Desktop": "__re-bulma_is-offset-1-desktop",
  "is2Desktop": "__re-bulma_is-2-desktop",
  "isOffset2Desktop": "__re-bulma_is-offset-2-desktop",
  "is3Desktop": "__re-bulma_is-3-desktop",
  "isOffset3Desktop": "__re-bulma_is-offset-3-desktop",
  "is4Desktop": "__re-bulma_is-4-desktop",
  "isOffset4Desktop": "__re-bulma_is-offset-4-desktop",
  "is5Desktop": "__re-bulma_is-5-desktop",
  "isOffset5Desktop": "__re-bulma_is-offset-5-desktop",
  "is6Desktop": "__re-bulma_is-6-desktop",
  "isOffset6Desktop": "__re-bulma_is-offset-6-desktop",
  "is7Desktop": "__re-bulma_is-7-desktop",
  "isOffset7Desktop": "__re-bulma_is-offset-7-desktop",
  "is8Desktop": "__re-bulma_is-8-desktop",
  "isOffset8Desktop": "__re-bulma_is-offset-8-desktop",
  "is9Desktop": "__re-bulma_is-9-desktop",
  "isOffset9Desktop": "__re-bulma_is-offset-9-desktop",
  "is10Desktop": "__re-bulma_is-10-desktop",
  "isOffset10Desktop": "__re-bulma_is-offset-10-desktop",
  "is11Desktop": "__re-bulma_is-11-desktop",
  "isOffset11Desktop": "__re-bulma_is-offset-11-desktop",
  "is12Desktop": "__re-bulma_is-12-desktop",
  "isOffset12Desktop": "__re-bulma_is-offset-12-desktop",
  "isNarrowWidescreen": "__re-bulma_is-narrow-widescreen",
  "isFullWidescreen": "__re-bulma_is-full-widescreen",
  "isThreeQuartersWidescreen": "__re-bulma_is-three-quarters-widescreen",
  "isTwoThirdsWidescreen": "__re-bulma_is-two-thirds-widescreen",
  "isHalfWidescreen": "__re-bulma_is-half-widescreen",
  "isOneThirdWidescreen": "__re-bulma_is-one-third-widescreen",
  "isOneQuarterWidescreen": "__re-bulma_is-one-quarter-widescreen",
  "isOffsetThreeQuartersWidescreen": "__re-bulma_is-offset-three-quarters-widescreen",
  "isOffsetTwoThirdsWidescreen": "__re-bulma_is-offset-two-thirds-widescreen",
  "isOffsetHalfWidescreen": "__re-bulma_is-offset-half-widescreen",
  "isOffsetOneThirdWidescreen": "__re-bulma_is-offset-one-third-widescreen",
  "isOffsetOneQuarterWidescreen": "__re-bulma_is-offset-one-quarter-widescreen",
  "is1Widescreen": "__re-bulma_is-1-widescreen",
  "isOffset1Widescreen": "__re-bulma_is-offset-1-widescreen",
  "is2Widescreen": "__re-bulma_is-2-widescreen",
  "isOffset2Widescreen": "__re-bulma_is-offset-2-widescreen",
  "is3Widescreen": "__re-bulma_is-3-widescreen",
  "isOffset3Widescreen": "__re-bulma_is-offset-3-widescreen",
  "is4Widescreen": "__re-bulma_is-4-widescreen",
  "isOffset4Widescreen": "__re-bulma_is-offset-4-widescreen",
  "is5Widescreen": "__re-bulma_is-5-widescreen",
  "isOffset5Widescreen": "__re-bulma_is-offset-5-widescreen",
  "is6Widescreen": "__re-bulma_is-6-widescreen",
  "isOffset6Widescreen": "__re-bulma_is-offset-6-widescreen",
  "is7Widescreen": "__re-bulma_is-7-widescreen",
  "isOffset7Widescreen": "__re-bulma_is-offset-7-widescreen",
  "is8Widescreen": "__re-bulma_is-8-widescreen",
  "isOffset8Widescreen": "__re-bulma_is-offset-8-widescreen",
  "is9Widescreen": "__re-bulma_is-9-widescreen",
  "isOffset9Widescreen": "__re-bulma_is-offset-9-widescreen",
  "is10Widescreen": "__re-bulma_is-10-widescreen",
  "isOffset10Widescreen": "__re-bulma_is-offset-10-widescreen",
  "is11Widescreen": "__re-bulma_is-11-widescreen",
  "isOffset11Widescreen": "__re-bulma_is-offset-11-widescreen",
  "is12Widescreen": "__re-bulma_is-12-widescreen",
  "isOffset12Widescreen": "__re-bulma_is-offset-12-widescreen",
  "isCentered": "__re-bulma_is-centered",
  "isGapless": "__re-bulma_is-gapless",
  "isGrid": "__re-bulma_is-grid",
  "isMultiline": "__re-bulma_is-multiline",
  "isVcentered": "__re-bulma_is-vcentered",
  "isDesktop": "__re-bulma_is-desktop",
  "container": "__re-bulma_container",
  "isFluid": "__re-bulma_is-fluid",
  "content": "__re-bulma_content",
  "footer": "__re-bulma_footer",
  "input": "__re-bulma_input",
  "select": "__re-bulma_select",
  "textarea": "__re-bulma_textarea",
  "isInline": "__re-bulma_is-inline",
  "checkbox": "__re-bulma_checkbox",
  "radio": "__re-bulma_radio",
  "help": "__re-bulma_help",
  "control": "__re-bulma_control",
  "hasAddons": "__re-bulma_has-addons",
  "isExpanded": "__re-bulma_is-expanded",
  "hasAddonsCentered": "__re-bulma_has-addons-centered",
  "hasAddonsRight": "__re-bulma_has-addons-right",
  "hasAddonsFullwidth": "__re-bulma_has-addons-fullwidth",
  "hasIcon": "__re-bulma_has-icon",
  "hasIconRight": "__re-bulma_has-icon-right",
  "isGrouped": "__re-bulma_is-grouped",
  "isGroupedCentered": "__re-bulma_is-grouped-centered",
  "isGroupedRight": "__re-bulma_is-grouped-right",
  "isHorizontal": "__re-bulma_is-horizontal",
  "controlLabel": "__re-bulma_control-label",
  "heading": "__re-bulma_heading",
  "heroVideo": "__re-bulma_hero-video",
  "heroButtons": "__re-bulma_hero-buttons",
  "hero": "__re-bulma_hero",
  "heroBody": "__re-bulma_hero-body",
  "heroFoot": "__re-bulma_hero-foot",
  "heroHead": "__re-bulma_hero-head",
  "isTransparent": "__re-bulma_is-transparent",
  "nav": "__re-bulma_nav",
  "tabs": "__re-bulma_tabs",
  "navMenu": "__re-bulma_nav-menu",
  "navItem": "__re-bulma_nav-item",
  "isBoxed": "__re-bulma_is-boxed",
  "isToggle": "__re-bulma_is-toggle",
  "isBold": "__re-bulma_is-bold",
  "navToggle": "__re-bulma_nav-toggle",
  "isFullheight": "__re-bulma_is-fullheight",
  "image": "__re-bulma_image",
  "isSquare": "__re-bulma_is-square",
  "is1By1": "__re-bulma_is-1by1",
  "is4By3": "__re-bulma_is-4by3",
  "is3By2": "__re-bulma_is-3by2",
  "is16By9": "__re-bulma_is-16by9",
  "is2By1": "__re-bulma_is-2by1",
  "is16X16": "__re-bulma_is-16x16",
  "is24X24": "__re-bulma_is-24x24",
  "is32X32": "__re-bulma_is-32x32",
  "is48X48": "__re-bulma_is-48x48",
  "is64X64": "__re-bulma_is-64x64",
  "is96X96": "__re-bulma_is-96x96",
  "is128X128": "__re-bulma_is-128x128",
  "label": "__re-bulma_label",
  "levelItem": "__re-bulma_level-item",
  "levelLeft": "__re-bulma_level-left",
  "levelRight": "__re-bulma_level-right",
  "isFlexible": "__re-bulma_is-flexible",
  "level": "__re-bulma_level",
  "hasTextCentered": "__re-bulma_has-text-centered",
  "hasTextLeft": "__re-bulma_has-text-left",
  "hasTextRight": "__re-bulma_has-text-right",
  "mediaLeft": "__re-bulma_media-left",
  "mediaRight": "__re-bulma_media-right",
  "mediaContent": "__re-bulma_media-content",
  "mediaNumber": "__re-bulma_media-number",
  "menu": "__re-bulma_menu",
  "menuList": "__re-bulma_menu-list",
  "menuLabel": "__re-bulma_menu-label",
  "message": "__re-bulma_message",
  "messageBody": "__re-bulma_message-body",
  "messageHeader": "__re-bulma_message-header",
  "modalBackground": "__re-bulma_modal-background",
  "modalContent": "__re-bulma_modal-content",
  "modalCard": "__re-bulma_modal-card",
  "modalCardHead": "__re-bulma_modal-card-head",
  "modalCardFoot": "__re-bulma_modal-card-foot",
  "modalCardTitle": "__re-bulma_modal-card-title",
  "modalCardBody": "__re-bulma_modal-card-body",
  "modal": "__re-bulma_modal",
  "isLargee": "__re-bulma_is-largee",
  "navLeft": "__re-bulma_nav-left",
  "navCenter": "__re-bulma_nav-center",
  "navRight": "__re-bulma_nav-right",
  "isTab": "__re-bulma_is-tab",
  "hasShadow": "__re-bulma_has-shadow",
  "notification": "__re-bulma_notification",
  "pagination": "__re-bulma_pagination",
  "panelIcon": "__re-bulma_panel-icon",
  "panelHeading": "__re-bulma_panel-heading",
  "panelList": "__re-bulma_panel-list",
  "panelBlock": "__re-bulma_panel-block",
  "panel": "__re-bulma_panel",
  "panelTabs": "__re-bulma_panel-tabs",
  "progress": "__re-bulma_progress",
  "section": "__re-bulma_section",
  "table": "__re-bulma_table",
  "th": "__re-bulma_th",
  "td": "__re-bulma_td",
  "isIcon": "__re-bulma_is-icon",
  "isBordered": "__re-bulma_is-bordered",
  "isStriped": "__re-bulma_is-striped",
  "isLeft": "__re-bulma_is-left",
  "isCenter": "__re-bulma_is-center",
  "isRight": "__re-bulma_is-right",
  "tile": "__re-bulma_tile",
  "isAncestor": "__re-bulma_is-ancestor",
  "isChild": "__re-bulma_is-child",
  "isParent": "__re-bulma_is-parent",
  "isVertical": "__re-bulma_is-vertical",
  "highlight": "__re-bulma_highlight",
  "isNormal": "__re-bulma_is-normal"
};